<template>
  <nav class="chapterhead-toc">
    <div v-if="chapterQueryLoading">Loading...</div>
    <ul class="chapterhead-toc__list">
      <li
        v-for="page in pages"
        :key="page.pageId"
        class="chapterhead-toc__item"
      >
        <!-- <nuxt-link
          :to="page.url"
          :title="page.label"
          class="chapterhead-toc__link"
        >
          {{ page.label }}
        </nuxt-link>-->
        <a
          :href="page.url"
          :title="page.label"
          class="chapterhead-toc__link"
          :target="page.target"
          v-html="page.label"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import { get } from "lodash";
import slugify from "slugify";
import { cleanMenuNode } from "~/apollo/dataUtils";
import GetChapterMenuPages from "~/apollo/queries/getChapterMenuPages.gql";

export default {
  name: "ChapterheadTOC",

  data() {
    return {
      menuItemId: null,
    };
  },

  computed: {
    chapterQueryLoading() {
      if (
        this.$apollo.queries.chapter &&
        this.$apollo.queries.chapter.loading
      ) {
        return this.$apollo.queries.chapter.loading;
      }
      return false;
    },
    pages() {
      if (this.$store.state.chapter.submenu) {
        return this.$store.state.chapter.submenu;
      }
      return [];
    },
  },

  apollo: {
    chapter: {
      query: GetChapterMenuPages,
      // Always get from the server instead of reading from the cache
      fetchPolicy: "network-only",
      prefetch({ app }) {
        // console.log("GetChapterMenuPages prefetch");
        const menuItemId = app.$cookies.get("menuItemId");
        // console.log(`prefetch menuItemId: ${menuItemId}`);
        return {
          id: menuItemId,
        };
      },
      variables() {
        const menuItemId = this.$cookies.get("menuItemId");
        // console.log("GetChapterMenuPages variables");
        // console.log("menuItemId:", menuItemId);
        return {
          id: menuItemId,
        };
      },
      update(data) {
        return data.menuItems;
      },
      // Optional result hook
      result({ data, loading, networkStatus }) {
        // console.log("GetChapterMenuPages got some result!");
        // console.log(JSON.stringify(data));
        const chap = data.menuItems.nodes[0];
        if (get(chap, "connectedObject.status") === "publish") {
          chap.childItems.nodes = chap.childItems.nodes.filter(
            (n) => n.connectedObject.status === "publish"
          );
        }
        this.$store.commit("chapter/setCurrentChapterSubmenu", data.menuItems);

        if (data.menuItems.nodes.length) {
          const menuItem = data.menuItems.nodes.find(
            (obj) =>
              slugify(obj.label, { lower: true }) === this.$route.params.chap
          );
          if (menuItem) {
            this.$cookies.set("menuItemId", menuItem.menuItemId);
          }
        }
      },
      error(error) {
        console.error(error);
      },
    },
  },

  created() {
    // console.log("ChapterheadTOC created");
    const menuItem = this.$store.state.menu.siteMenuData.find(
      (obj) => slugify(obj.label, { lower: true }) === this.$route.params.chap
    );
    if (menuItem) {
      this.menuItemId = menuItem.menuItemId;
    }
  },
};
</script>

<style lang="scss">
.chapterhead-toc {
  font-family: $font-sans;
  font-size: 1.3rem;
  font-style: initial;
  font-weight: 500;
  &__list {
    list-style-type: none;
    padding: 0;
  }
  &__item {
    margin: 1rem 0 0.2rem;
    padding: 0;
  }
  &__link {
    color: white;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
